module.exports = __webpack_public_path__ + "static/img/video_eicad.1c99670b.png";